import AuthService from './AuthService';
import translation from './translation.json';

const translate = id => {
    const language = AuthService.getLanguage() ?? 'English'
    let label = translation.find(l => l.id === id).lable[language]
    return label;
}

export default translate;